import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAuthStore = create(
    persist(
        (set, get) => ({
            user: null,
            tokens: {
                accessToken: null,
                refreshToken: null,
            },
            isAuthenticated: false,

            login: (userData, tokens) => {
                // 로컬 스토리지에 토큰 저장
                localStorage.setItem('ab_at', tokens.accessToken);
                localStorage.setItem('ab_rt', tokens.refreshToken);

                set({
                    user: userData,
                    tokens: {
                        accessToken: tokens.accessToken,
                        refreshToken: tokens.refreshToken,
                    },
                    isAuthenticated: userData.status === 'ACTIVE',
                });
            },

            updateTokens: (newTokens) => {
                // 로컬 스토리지 업데이트
                if (newTokens.accessToken) {
                    localStorage.setItem('ab_at', newTokens.accessToken);
                    localStorage.setItem('ab_rt', newTokens.refreshToken);
                }

                set((state) => ({
                    tokens: {
                        ...state.tokens,
                        ...newTokens,
                    }
                }));
            },

            logout: () => {
                // 로컬 스토리지에서 토큰 제거
                localStorage.removeItem('ab_at');
                localStorage.removeItem('ab_rt');

                set({
                    user: null,
                    tokens: {
                        accessToken: null,
                        refreshToken: null,
                    },
                    isAuthenticated: false,
                });
            },

            // 사용자 이름 가져오기
            getUserName: () => {
                const { user } = get();
                return user?.name || '';
            },

            // 로컬 스토리지와 상태 동기화
            syncAuthState: () => {
                const accessToken = localStorage.getItem('ab_at');

                if (accessToken) {
                    // 토큰이 있지만 상태에 반영되지 않은 경우
                    if (!get().isAuthenticated) {
                        try {
                            // JWT 디코딩으로 사용자 정보 추출
                            const tokenParts = accessToken.split('.');
                            if (tokenParts.length === 3) {
                                const base64 = tokenParts[1].replace(/-/g, '+').replace(/_/g, '/');
                                const jsonPayload = decodeURIComponent(
                                    atob(base64)
                                    .split('')
                                    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                                    .join('')
                                );
                                const payload = JSON.parse(jsonPayload);

                                set({
                                    user: {
                                        userId: payload.userId,
                                        email: payload.sub,
                                        name: payload.name,
                                        roles: payload.roles || []
                                    },
                                    tokens: {
                                        accessToken,
                                    },
                                    isAuthenticated: true
                                });
                                return true;
                            }
                        } catch (error) {
                            console.error('토큰 동기화 오류:', error);
                        }
                    } else {
                        return true;
                    }
                } else {
                    // 토큰이 없는데 인증 상태인 경우 초기화
                    if (get().isAuthenticated) {
                        set({
                            user: null,
                            tokens: {
                                accessToken: null,
                                refreshToken: null,
                            },
                            isAuthenticated: false,
                        });
                    }
                }
                return false;
            }
        }),
        {
            name: 'auth-storage',
        }
    )
)